(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    Marquee3k.init({ selector: 'marquees' })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector('.product-recommendations')
    if (productRecommendationsSection === null) {
      return
    }
    // Build request URL
    var requestUrl = productRecommendationsSection.dataset.url
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest()
    request.open('GET', requestUrl)
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div')
        container.innerHTML = request.response
        productRecommendationsSection.innerHTML = container.querySelector('.product-recommendations').innerHTML

        theme.peekCarousel.init(
          productRecommendationsSection,
          $('.js-related-product-carousel', productRecommendationsSection),
          '.productRecommendations',
          function () {
            return $(window).width() < 768
          },
          false
        )
        theme.initUniformHeightMonitor(
          productRecommendationsSection,
          '.product-block__image-container',
          '.product-block__image-container .image-one'
        )
      }
    }
    request.send()
  }
  // Reload the section in the editor when a setting changes
  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
      loadProductRecommendationsIntoSection()
    }
  })
  document.addEventListener('shopify:section:unload', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
      theme.destroyUniformHeightMonitor($('.product-recommendations', event.target))
      theme.peekCarousel.destroy(
        $('.product-recommendations', event.target),
        $('.js-related-product-carousel', event.target),
        '.productRecommendations'
      )
    }
  })
  // Fetching the recommendations on page load
  document.addEventListener('DOMContentLoaded', function (event) {
    loadProductRecommendationsIntoSection()
  })

  } catch(e) { console.error(e); }
})();
})();
